
      import API from "!../../../node_modules/.pnpm/style-loader@3.3.4_webpack@5.96.1/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../node_modules/.pnpm/style-loader@3.3.4_webpack@5.96.1/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../node_modules/.pnpm/style-loader@3.3.4_webpack@5.96.1/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../node_modules/.pnpm/style-loader@3.3.4_webpack@5.96.1/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../node_modules/.pnpm/style-loader@3.3.4_webpack@5.96.1/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../node_modules/.pnpm/style-loader@3.3.4_webpack@5.96.1/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../node_modules/.pnpm/@nrwl+web@13.1.2_9a35ccffcf4e8ba9ca59f0202d7725c1/node_modules/@nrwl/web/src/utils/webpack/plugins/raw-css-loader.js!../../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.3.0+webpack@5.96.1/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].oneOf[4].use[2]!./globalStyle.css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../node_modules/.pnpm/@nrwl+web@13.1.2_9a35ccffcf4e8ba9ca59f0202d7725c1/node_modules/@nrwl/web/src/utils/webpack/plugins/raw-css-loader.js!../../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.3.0+webpack@5.96.1/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].oneOf[4].use[2]!./globalStyle.css";
       export default content && content.locals ? content.locals : undefined;
